import { Component, OnInit, OnDestroy } from '@angular/core';
import { ToastAnimationState, toastAnimations } from './toast-animation';
import { ToastRef } from './toast-ref';
import { ToastData } from './toast-data';
import { defaultToastConfig } from './toast-config';

@Component({
  selector: 'tca-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
  animations: [toastAnimations.fadeToast],
})
export class ToastComponent implements OnInit, OnDestroy {
  animationState: ToastAnimationState = 'default';
  iconType: string;
  toastConfig = defaultToastConfig;

  private intervalId: any;

  constructor(
    readonly data: ToastData,
    readonly ref: ToastRef,
  ) { }

  ngOnInit() {
    this.intervalId = setTimeout(() => this.animationState = 'closing', this.delay);
  }

  ngOnDestroy() {
    clearTimeout(this.intervalId);
  }

  close() {
    this.ref.close();
  }

  onFadeFinished(event: any) {
    const { toState } = event;
    const isFadeOut = (toState as ToastAnimationState) === 'closing';
    const itFinished = this.animationState === 'closing';

    if (isFadeOut && itFinished) {
      this.close();
    }
  }

  get backgroundColor() { return this.data.backgroundColor; }
  get textColor() { return this.data.textColor; }
  get delay() { return this.data.delay; }

}
